/**
 * ID é sempre equivalente a string retornada na chave name da api, sem espaços
 * e em camel case
 */
export const OPPORTUNITIES_IDS = {
  superPreco: 'superPreco',
  carDelivery: 'carDelivery',
  trocaComTroco: 'trocaComTroco',
  'visão360°': 'visão360°',
  vistoriado: 'vistoriado',
}

/**
 * Chaves extras para serem adicionados ao factory dos item oportunidades do
 * fitro
 */
export const OPPORTUNITIES_INFO = {
  carDelivery: {
    showBadge: true,
  },
  trocaComTroco: {
    displayName: 'Troca com troco',
    showBadge: true,
  },
  superPreco: {
    displayName: 'Super Preço',
    showBadge: true,
  },
  'visão360°': {
    displayName: 'Visão360º',
    showBadge: false,
    cta: 'Ver 360°',
  },
  vistoriado: {
    displayName: 'Vistoriado',
    showBadge: false
  },
  default: {
    showBadge: false,
  },
}

/**
 * Ordem em que os filtros serão apresentados
 * A ordem é definida pelo objeto OPPORTUNITIES_IDS
 */
export const OPPORTUNITIES_SORT = Object.entries(OPPORTUNITIES_IDS).map(
  ([, item]) => item
)
